import { createHyperscript } from './hyperscript';
var jsx = createHyperscript();
export { jsx };